module.exports = __webpack_public_path__ + "static/flags/GL-a52ea5b7f97c0b78f319714a1e39ddf9.gif";